import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { useQueryParam, StringParam } from 'use-query-params';

import Wizard from 'vibo-ui/Wizard';
import AuthLayout from '../../layouts/SignInLayout';
import { WizardState } from 'vibo-ui/Wizard/WizardStepContext';
import { SignInContextProvider } from 'components/context/SignInContext';

import { authStorage } from 'utils/helpers/auth';
import { useViboTheme } from 'components/context/ViboThemeContext';

import { isLoggedInVar } from 'graphql/cache';
import { SIGN_IN_WIZARD_SCHEMA } from './constants';

import useStyles from './style';

const SignIn: FC = () => {
  const classes = useStyles();

  const [token] = useQueryParam('id_token', StringParam);
  const [success] = useQueryParam('success', StringParam);

  const navigate = useNavigate();

  const isLoggedIn = useReactiveVar(isLoggedInVar);

  const { resetToAppColor } = useViboTheme();

  useEffect(() => {
    const localstorageSearch = localStorage.getItem('appleLoginSearch');

    if (!!localstorageSearch) {
      navigate(`/join-event?url=${localstorageSearch}&success=${success}&id_token=${token}`);
    }

    if (!isLoggedIn) {
      authStorage.clearTokens();
    }
  }, [token, success, isLoggedIn]);

  useEffect(() => {
    !isLoggedIn && resetToAppColor();
  }, [isLoggedIn]);

  return (
    <AuthLayout>
      <WizardState>
        <SignInContextProvider>
          <Wizard className={classes.signUpWizard}>
            {Object.entries(SIGN_IN_WIZARD_SCHEMA).map(option => {
              const stepName = option[0];
              const StepComponent = option[1];

              return (
                <Wizard.Step stepName={stepName} key={stepName}>
                  <StepComponent />
                </Wizard.Step>
              );
            })}
          </Wizard>
        </SignInContextProvider>
      </WizardState>
    </AuthLayout>
  );
};

export default SignIn;
